<template>
  <div>
    <div class="lg:w-[50%]">
      <b-form-group
        id="input-group-6-label"
        label-for="select-product"
      >
        <template #label>
          <div class=" mb-[8px]">
            Nama Produk*
          </div>
        </template>
        <v-select
          id="select-product"
          v-model="selectedProductsData"
          name="product_ids"
          placeholder="Pilih Produk"
          required
          label="product_name"
          multiple
          :options="listProducts"
          class="custom-product-select"
          :filterable="false"
          :selectable="(option) => selectedProductsData.length < 5 "
          @input="$emit('update:address_id', $event)"
          @open="onProductDropdownOpen"
          @close="onProductDropdownClose"
          @search="onProductSearch"
        >
          <template #search="{ attributes, events }">
            <div class="flex items-center gap-2 w-full">
              <div
                v-if="selectedProductsData.length > 0 && !isProductSelectOpen"
                class="px-2 text-[#333333] whitespace-nowrap"
              >
                {{ selectedProductsData.length }} Produk Terpilih
              </div>
              <input
                class="vs__search pl-2 text-gray-700"
                style="width: 100%;"
                v-bind="attributes"
                v-on="events"
              >
            </div>
          </template>
          <template #list-header>
            <li class="sticky top-0 z-10 bg-gray-100 border-b">
              <div class="flex flex-col sm:flex-row items-center p-2.5 py-2 font-medium text-gray-600">
                <div class="w-full sm:w-5/12">
                  Produk
                </div>
                <div class="w-full sm:w-3/12 text-center sm:text-left">
                  Variasi
                </div>
                <div class="w-full sm:w-3/12 text-center sm:text-left">
                  Harga
                </div>
                <div class="w-full sm:w-2/12 text-center">
                  Stok
                </div>
              </div>
            </li>
          </template>
          <template #list-footer>
            <div
              v-if="isLoadingProducts"
              class="text-center text-gray-500 p-3"
            >
              <b-spinner
                small
                variant="primary"
              />
              <span class="ml-2">Memuat produk...</span>
            </div>
            <div
              v-else-if="!hasMoreProducts && listProducts && listProducts.length > 0"
              class="text-center text-gray-400 p-3 text-sm"
            >
              <b-icon icon="check-circle" />
              <span class="ml-2">Semua produk sudah ditampilkan</span>
            </div>
          </template>
          <template #no-options>
            <div class="flex my-1 justify-center">
              <div class="border w-fit rounded-md p-[8px]">
                <b-img
                  width="30"
                  height="30"
                  center
                  src="https://storage.googleapis.com/komerce/assets/icons/search-abu.svg"
                />
              </div>
            </div>
            <div class="text-[#333333]">
              Tidak ada produk tersedia
            </div>
            <div class=" mb-2 text-[#828282]">
              Tambahkan produk kamu
            </div>
          </template>

          <template #option="data">
            <div>
              <div
                class="flex flex-col sm:flex-row items-center sm:items-center p-2.5 py-2"
              >
                <div class="flex items-center gap-3 w-full sm:w-5/12  sm:mb-0">
                  <b-img
                    :src="data.product_image ? data.product_image : 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'"
                    alt="Product Image"
                    class="w-10 h-10 object-cover rounded flex-shrink-0"
                  />
                  <div class="flex-grow min-w-0">
                    <div
                      class="font-medium  leading-snug truncate"
                      :title="data.product_name"
                    >
                      {{ data.product_name }}
                    </div>
                    <div
                      class=" leading-snug truncate"
                      :title="data.product_sku"
                    >
                      SKU: {{ data.product_sku }}
                    </div>
                  </div>
                </div>
                <div
                  class="w-full sm:w-3/12    sm:mb-0 text-center sm:text-left truncate"
                  :title="data.product_variant || '-'"
                >
                  {{ data.product_variant || '-' }}
                </div>
                <div class="w-full sm:w-3/12    sm:mb-0 text-center sm:text-left ">
                  {{ data.product_price | currency }}
                </div>
                <div class="w-full sm:w-2/12    sm:mb-0 text-center">
                  {{ data.product_stock }}
                </div>
              </div>
            </div>
          </template>
        </v-select>
      </b-form-group>
      <div
        v-if="isResolvingSelectedProducts"
        class="flex items-center gap-2 my-2 text-[#828282] text-sm"
      >
        <b-spinner
          small
          variant="primary"
        />
        <span>Memuat produk terpilih...</span>
      </div>
      <div class="grid my-2 grid-cols-1 lg:grid-cols-3 gap-3">
        <div
          v-for="(item, index) in computedSelectedProducts"
          :key="index"
          class="rounded-lg p-[3px] border"
          :class="getProductPriceAfterDiscount(item) < 10000 ? 'bg-red-50 border-red-300' : 'bg-[#F4F4F4]'"
        >
          <div class="flex justify-between items-center gap-2">
            <div class="flex items-center gap-2">
              <b-img
                class="w-14"
                rounded
                :src="(item.product_image || item.url) ? (item.product_image || item.url) : 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'"
              />
              <div class="grid gap-2">
                <div class="font-medium  leading-none tracking-normal text-[#333333]">
                  {{ (item.product_name || item.name) && (item.product_name || item.name).length > 15 ? (item.product_name || item.name).slice(0, 15) + '...' : (item.product_name || item.name) || '-' }}
                </div>
                <div class=" font-normal  leading-none tracking-normal text-[#828282]">
                  SKU: {{ item.product_sku || '-' }}
                </div>
              </div>
            </div>
            <a @click="onUnselect(item.id || item.product_id)">
              <b-icon icon="x" />
            </a>
          </div>
        </div>
      </div>
      <b-form-group
        id="input-group-1"
        label-for="input-2"
      >
        <template #label>
          <div class="flex mb-[8px] justify-between items-center">
            <span class="text-semibold">Gudang*</span>
            <b-button
              variant="primary"
              size="sm"
              class="!p-1"
              :disabled="isAddWarehouse"
              @click="onAddWarehouse"
            >
              <b-icon
                icon="plus"
              />
              Tambah Gudang
            </b-button>
          </div>

        </template>
        <v-select
          v-show="!isAddWarehouse"
          id="input-2"
          v-model="formData.address_id"
          name="address_id"
          placeholder="Pilih Gudangmu"
          :reduce="item => item.id"
          required
          label="name"
          :options="warehouseList"
          @input="$emit('update:address_id', $event)"
        >
          <template #no-options>
            <div class="flex my-1 justify-center">
              <div class="border w-fit rounded-md p-[8px]">
                <b-img
                  width="30"
                  height="30"
                  center
                  src="https://storage.googleapis.com/komerce/assets/icons/search-abu.svg"
                />
              </div>
            </div>
            <div class="text-[#333333]">
              Belum ada data gudang
            </div>
            <div class=" mb-2 text-[#828282]">
              Tambahkan gudang kamu
            </div>
          </template>
          <template #selected-option="data">
            <div>
              {{ data.name }}
            </div>
          </template>
          <template #option="data">
            <div>
              <div class="text-semibold">
                {{ data.name }}
              </div>
              <div class="">
                {{ data.detail_address }}
              </div>
            </div>
          </template>
        </v-select>
      </b-form-group>
      <AddWhereHouse
        v-show="isAddWarehouse"
        @onAddWareHouse="onAddWarehouse"
        @refresh="onRefreshWarehouseList"
      />

    </div>
    <div class="flex justify-center items-center mt-3">
      <hr class="h-1 w-[70%] border-t border-gray-300">
    </div>
    <b-row
      cols="1"
      cols-lg="2"
    >
      <b-col>
        <div>
          <b-form-group
            id="switch 3"
            class="mt-3"
            label="Pilih Ekspedisi*"
            label-for="switch"
            label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
          >
            <div
              v-for="(item, index) in shipment"
              :key="index"
              class="border rounded-lg p-1 mt-1"
            >
              <div
                role="button"
                class="flex  items-center  justify-between"
                @click="item.show = !item.show"
              >
                <div class="flex gap-1">
                  <div><b-img
                    width="50"
                    :src="item.image_path"
                  /></div>
                  <div>{{ item.shipping_name }}</div>
                </div>
                <b-icon
                  role="button"
                  :icon="`chevron-${item.show ? 'up' : 'down'}`"
                />
              </div>
              <div v-show="item.show">
                <div
                  v-for="(itemService, indexService) in item.services"
                  :key="indexService"
                  class="flex justify-between mt-1 transition-all duration-300 items-center "
                >
                  <div>
                    {{ itemService.service_name }}
                  </div>
                  <b-form-checkbox
                    :id="`checkbox-eks${index}-${indexService}`"
                    v-model="itemService.is_selected"
                    switch
                    @change="selectShipment"
                  />

                </div>
              </div>
            </div>
          </b-form-group>
        </div>
      </b-col>
      <b-col>
        <b-form-group
          class="mt-3"
          label="Promo"
          label-for="switcsh"
          label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
        >
          <div class="">
            <div class=" border p-1 rounded-md  bg-white">
              <div class="flex items-center justify-between gap-2">
                <div class="flex gap-2 items-center">
                  <div class="font-medium text-gray-800">
                    Promo & Diskon
                  </div>
                </div>
                <b-form-checkbox
                  id="checkbox-promo-diskon"
                  v-model="promoEnabled"
                  switch
                  @change="onPromoDiscountToggle"
                />
              </div>
              <div
                v-if="promoEnabled"
                class="mt-4 space-y-4"
              >
                <!-- Diskon Ongkir Section -->
                <div class="border rounded-lg p-1 bg-white">
                  <div class="flex items-center justify-between mb-1">
                    <h4 class="font-medium text-gray-800 mb-0 text-base">
                      Diskon Ongkir
                    </h4>
                  </div>
                  <div
                    class="space-y-4"
                  >
                    <div class="space-y-4 w-70%">
                      <b-form-group
                        label-cols-lg="3"
                        label="Besar Diskon (%)"
                        label-for="diskon-ongkir-persen"
                        label-class="!text-sm font-medium text-gray-700"
                      >
                        <b-form-input
                          id="diskon-ongkir-persen"
                          v-model="formData.shipping_discount"
                          type="number"
                          placeholder="50%"
                          class=""
                          min="0"
                          max="100"
                          @input="onShippingDiscountInput"
                          @keypress="onShippingDiscountKeypress"
                          @paste="onShippingDiscountPaste"
                        />
                      </b-form-group>
                      <b-form-group
                        label="Coverage"
                        label-cols-lg="3"
                        label-for="coverage-select"
                        label-class="text-sm font-medium text-gray-700"
                      >
                        <v-select
                          id="coverage-select"
                          v-model="selectedCoverage"
                          :options="availableCoverageOptions"
                          :selectable="isCoverageSelectable"
                          placeholder="Seluruh Indonesia"
                          class="vue-select-custom"
                          @input="addCoverage"
                        />
                        <div class="flex mt-1 flex-wrap gap-2">
                          <span
                            v-for="coverage in selectedCoverages"
                            :key="coverage"
                            class="inline-flex items-center px-1 py-[8px] rounded-full text-sm bg-gray-200 text-gray-700 border"
                          >
                            {{ getCoverageLabel(coverage) }}
                            <button
                              class="ml-2 text-gray-500 hover:text-gray-700"
                              @click="removeCoverage(coverage)"
                            >
                              ×
                            </button>
                          </span>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <!-- Diskon Produk Section -->
                <div class="border rounded-lg p-1 bg-white">
                  <div class="flex items-center justify-between mb-1">
                    <h4 class="font-medium text-gray-800 mb-0 text-base">
                      Diskon Produk
                    </h4>
                  </div>
                  <div
                    class="space-y-3"
                  >
                    <b-form-group
                      label-cols-lg="3"
                      label="Besar Diskon (%)"
                      label-for="diskon-produk-persen"
                      label-class="!text-sm font-medium text-gray-700"
                    >
                      <b-form-input
                        id="diskon-produk-persen"
                        v-model.number="formData.product_discount"
                        type="number"
                        max="100"
                        min="0"
                        placeholder="50%"
                        class=""
                        @input="onProductDiscountInput"
                        @keypress="onProductDiscountKeypress"
                        @paste="onProductDiscountPaste"
                      />
                    </b-form-group>
                  </div>
                </div>

                <!-- Diskon Pembayaran Section -->
                <div class="border rounded-lg p-1 bg-white">
                  <div class="flex items-center justify-between mb-1">
                    <h4 class="font-medium text-gray-800 mb-0 text-base">
                      Diskon Pembayaran
                    </h4>
                  </div>
                  <div
                    class="space-y-3"
                  >
                    <b-form-group
                      label-cols-lg="3"
                      label="Besar Diskon (%)"
                      label-for="diskon-pembayaran-value"
                      label-class="!text-sm font-medium text-gray-700"
                    >
                      <b-form-input
                        id="diskon-pembayaran-value"
                        v-model.number="formData.payment_discount"
                        type="number"
                        max="100"
                        min="0"
                        placeholder="0%"
                        class=""
                        @input="onPaymentDiscountInput"
                        @keypress="onPaymentDiscountKeypress"
                        @paste="onPaymentDiscountPaste"
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { mapState } from 'vuex'
import AddWhereHouse from './AddWhereHouse.vue'
import apiGetShipment from './service/api.shipment.service'
import { apiGetProuctList } from './service/api.product.service'

export default {
  components: {
    VSelect,
    AddWhereHouse,
  },
  filters: {
    currency(value) {
      if (value === null || value === undefined) return '-'
      const numValue = Number(value)
      if (Number.isNaN(numValue)) return '-'
      return `Rp${numValue.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`
    },
  },
  props: {
    formData: {
      type: Object,
      default: () => ({
        address_id: null,
        product_ids: [],
        shipments: [],
        product_discount: 0,
        payment_discount: 0,
        shipping_discount: 0,
        coverage_discount: [],
      }),
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    hasInvalidPrice: {
      type: Boolean,
      default: false,
    },
    invalidPriceProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchKeyword: '',
      searchDebounceTimer: null,
      isProductSelectOpen: false,
      selectedProductsData: [],
      promoOverride: null,
      isAddWarehouse: false,
      isOnSelectProduct: false,
      shipment: [],
      selectedCoverage: null,
      selectedCoverages: [],
      coverageOptions: [
        { label: 'Seluruh Indonesia', value: 'indonesia' },
        { label: 'Pulau Jawa', value: 'java_island' },
        { label: 'Luar Pulau Jawa', value: 'outside_java' },
        { label: 'Jabodetabek', value: 'jabodetabek' },
      ],
      productPage: 0,
      productLimit: 15,
      isLoadingProducts: false,
      hasMoreProducts: true,
      scrollDebounceTimer: null,
      localProductList: [],
      isResolvingSelectedProducts: false,
      fetchMissingProductsTimer: null,
      resolveSelectedProductsRunning: false,
    }
  },
  computed: {
    ...mapState('komchat', {
      warehouseList: state => state.warehouseList || [],
    }),
    listProducts() {
      return this.localProductList || []
    },
    hasAnyDiscount() {
      const f = this.formData || {}
      const hasValue = v => !!v && (Number(v) > 0 || (Array.isArray(v) && v.length > 0) || (typeof v === 'string' && v.trim() !== ''))
      return hasValue(f.product_discount) || hasValue(f.payment_discount) || hasValue(f.shipping_discount) || hasValue(f.coverage_discount)
    },
    promoEnabled: {
      get() {
        return this.promoOverride !== null ? this.promoOverride : this.hasAnyDiscount
      },
      set(value) {
        this.promoOverride = value
      },
    },
    computedSelectedProducts() {
      return this.selectedProductsData
    },
    availableCoverageOptions() {
      return this.coverageOptions.filter(option => !this.selectedCoverages.includes(option.value))
    },
    hasInvalidProductPrice() {
      // Get selected products
      const selectedProducts = this.computedSelectedProducts

      if (!selectedProducts || selectedProducts.length === 0) return false

      // Check if any product has price below 10000 (either original or after discounts)
      return selectedProducts.some(product => {
        const originalPrice = Number(product.product_price || product.price) || 0

        // Check if original price is below 10000
        if (originalPrice < 10000) return true

        // Calculate product discount
        const productDiscountPercent = Number(this.formData.product_discount) || 0
        const productDiscountAmount = (originalPrice * productDiscountPercent) / 100
        const priceAfterProductDiscount = originalPrice - productDiscountAmount

        // Calculate payment discount
        const paymentDiscountPercent = Number(this.formData.payment_discount) || 0
        const paymentDiscountAmount = (priceAfterProductDiscount * paymentDiscountPercent) / 100
        const finalPrice = priceAfterProductDiscount - paymentDiscountAmount

        // Check if final price is below 10000
        return finalPrice < 10000
      })
    },
    computedInvalidPriceProducts() {
      const selectedProducts = this.computedSelectedProducts

      if (!selectedProducts || selectedProducts.length === 0) return []

      return selectedProducts.filter(product => {
        const originalPrice = Number(product.product_price || product.price) || 0

        // Check if original price is below 10000
        if (originalPrice < 10000) return true

        // Check if price after discount is below 10000
        return this.getProductPriceAfterDiscount(product) < 10000
      }).map(product => product.product_name || product.name)
    },
  },
  watch: {
    formData: {
      handler() {
        this.validateForm()
      },
      deep: true,
      immediate: true,
    },
    selectedProductsData: {
      handler(newVal) {
        this.formData.product_ids = newVal.map(item => item.id)
        this.validateForm()
      },
      deep: true,
    },
    'formData.coverage_discount': {
      immediate: true,
      handler(newVal) {
        if (typeof newVal === 'string' && newVal.trim() !== '') {
          this.selectedCoverages = [newVal]
        } else if (Array.isArray(newVal)) {
          this.selectedCoverages = [...newVal]
        } else if (!newVal) {
          this.selectedCoverages = []
        }
      },
    },
    isOnSelectProduct(isOpen) {
      if (isOpen) {
        document.addEventListener('mousedown', this.handleClickOutside)
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside)
      }
    },

    'formData.shipments': {
      handler() {
        this.updateShipmentSelection()
        this.validateForm()
      },
      deep: true,
    },
    'formData.product_ids': {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.isEditMode && newVal && newVal.length > 0) {
          if (this.formData.products && this.formData.products.length > 0 && this.selectedProductsData.length === 0) {
            this.selectedProductsData = [...this.formData.products]
          } else {
            this.scheduleFetchMissingSelectedProducts()
          }
        }
      },
    },
    localProductList: {
      handler() {
        if (this.isEditMode && this.formData.product_ids?.length > 0) {
          this.mergeSelectedProductsFromLocalList()
        }
      },
      deep: true,
    },
    'formData.product_discount': {
      handler() {
        this.validateForm()
      },
    },
    'formData.payment_discount': {
      handler() {
        this.validateForm()
      },
    },
    hasInvalidProductPrice: {
      immediate: true,
      handler(newVal) {
        this.$emit('update:hasInvalidPrice', newVal)
      },
    },
    computedInvalidPriceProducts: {
      immediate: true,
      handler(newVal) {
        this.$emit('update:invalidPriceProducts', newVal)
      },
    },

  },
  created() {
    this.validateForm()
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside)
    if (this.scrollDebounceTimer) {
      clearTimeout(this.scrollDebounceTimer)
    }
    if (this.fetchMissingProductsTimer) {
      clearTimeout(this.fetchMissingProductsTimer)
    }
    // Cleanup intersection observer
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
    }
  },
  async mounted() {
    this.$store.dispatch('komchat/getWarehouseList')
    this.getShipmentData()
    await this.loadProducts()
    await this.fetchMissingSelectedProducts()
  },
  methods: {
    // Reusable function untuk validasi discount
    validateDiscountKeypress(event, fieldName) {
      // Hanya izinkan angka, backspace, delete, arrow keys, tab, enter
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter']
      const isNumber = /[0-9]/.test(event.key)
      const isAllowedKey = allowedKeys.includes(event.key)

      if (!isNumber && !isAllowedKey) {
        event.preventDefault()
        return
      }

      // Cek jika input akan melebihi 100
      const currentValue = this.formData[fieldName] || ''
      const newValue = currentValue + event.key
      const numValue = parseFloat(newValue)

      if (!Number.isNaN(numValue) && numValue > 100) {
        event.preventDefault()
        this.formData[fieldName] = 100
      }
    },
    validateDiscountInput(event, fieldName) {
      // Handle case where event.target might be undefined
      let value
      if (event && event.target && event.target.value !== undefined) {
        value = event.target.value
      } else if (event !== undefined) {
        value = event
      } else {
        this.formData[fieldName] = 0
        return
      }

      if (value === '' || value === null || value === undefined) {
        this.formData[fieldName] = 0
        return
      }

      const numValue = parseFloat(value)
      if (Number.isNaN(numValue)) {
        this.formData[fieldName] = 0
        return
      }

      // Batasi nilai antara 0 dan 100
      if (numValue > 100) {
        this.formData[fieldName] = 100
      } else if (numValue < 0) {
        this.formData[fieldName] = 0
      } else {
        this.formData[fieldName] = numValue
      }
    },
    validateDiscountPaste(event, fieldName) {
      event.preventDefault()
      const pastedData = event.clipboardData.getData('text')
      const numValue = parseFloat(pastedData)

      if (Number.isNaN(numValue)) {
        this.formData[fieldName] = 0
        return
      }

      // Batasi nilai antara 0 dan 100
      if (numValue > 100) {
        this.formData[fieldName] = 100
      } else if (numValue < 0) {
        this.formData[fieldName] = 0
      } else {
        this.formData[fieldName] = numValue
      }
    },
    // Wrapper functions untuk field spesifik
    onShippingDiscountKeypress(event) {
      this.validateDiscountKeypress(event, 'shipping_discount')
    },
    onShippingDiscountInput(event) {
      this.validateDiscountInput(event, 'shipping_discount')
    },
    onShippingDiscountPaste(event) {
      this.validateDiscountPaste(event, 'shipping_discount')
    },
    onProductDiscountKeypress(event) {
      this.validateDiscountKeypress(event, 'product_discount')
    },
    onProductDiscountInput(event) {
      this.validateDiscountInput(event, 'product_discount')
    },
    onProductDiscountPaste(event) {
      this.validateDiscountPaste(event, 'product_discount')
    },
    onPaymentDiscountKeypress(event) {
      this.validateDiscountKeypress(event, 'payment_discount')
    },
    onPaymentDiscountInput(event) {
      this.validateDiscountInput(event, 'payment_discount')
    },
    onPaymentDiscountPaste(event) {
      this.validateDiscountPaste(event, 'payment_discount')
    },
    onSubmit() {
      this.$emit('submit')
    },
    onRefreshWarehouseList() {
      this.$store.dispatch('komchat/getWarehouseList')
    },
    onAddWarehouse() {
      this.isAddWarehouse = !this.isAddWarehouse
    },
    scheduleFetchMissingSelectedProducts() {
      if (this.fetchMissingProductsTimer) {
        clearTimeout(this.fetchMissingProductsTimer)
      }
      this.fetchMissingProductsTimer = setTimeout(() => {
        this.fetchMissingProductsTimer = null
        this.fetchMissingSelectedProducts()
      }, 200)
    },
    async waitForProductListRequestIdle() {
      let waits = 0
      while (this.isLoadingProducts && waits < 250) {
        waits += 1
        // eslint-disable-next-line no-await-in-loop
        await new Promise(resolve => setTimeout(resolve, 20))
      }
    },
    mergeSelectedProductsFromLocalList() {
      const ids = this.formData.product_ids || []
      if (!ids.length) return

      const fromList = new Map(this.localProductList.map(p => [p.id, p]))
      const previous = new Map(this.selectedProductsData.map(p => [p.id, p]))

      this.selectedProductsData = ids
        .map(id => fromList.get(id) || previous.get(id))
        .filter(Boolean)
    },
    async fetchMissingSelectedProducts() {
      if (!this.isEditMode || !this.formData.product_ids?.length) return
      if (this.resolveSelectedProductsRunning) return

      const targetIds = this.formData.product_ids
      const isMissing = () => targetIds.some(
        id => !this.localProductList.some(p => p.id === id),
      )

      this.resolveSelectedProductsRunning = true
      this.isResolvingSelectedProducts = true
      try {
        await this.waitForProductListRequestIdle()
        this.mergeSelectedProductsFromLocalList()

        while (isMissing() && this.hasMoreProducts) {
          // eslint-disable-next-line no-await-in-loop
          await this.loadProducts(false)
          // eslint-disable-next-line no-await-in-loop
          await this.waitForProductListRequestIdle()
          this.mergeSelectedProductsFromLocalList()
        }
      } finally {
        this.isResolvingSelectedProducts = false
        this.resolveSelectedProductsRunning = false
      }
    },
    onUnselect(id) {
      this.selectedProductsData = this.selectedProductsData.filter(product => (product.id || product.product_id) !== id)
    },
    onSelectProduct() {
      this.isOnSelectProduct = !this.isOnSelectProduct
    },
    validateForm() {
      const requiredFields = [
        'address_id',
        'product_ids',
      ]
      const isFormValid = requiredFields.every(field => {
        const value = this.formData[field]
        if (field === 'product_ids') {
          return Array.isArray(value) && value?.length > 0
        }
        return value !== undefined && value !== null && String(value).trim() !== ''
      })

      const hasShipment = this.formData.shipments && this.formData.shipments.length > 0

      if (!isFormValid || !hasShipment) {
        this.$emit('update:disableNext', true)
      } else {
        this.$emit('update:disableNext', false)
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.productDropdownContainer
      if (dropdown && !dropdown.contains(event.target)) {
        const triggerButton = document.getElementById('input-group-6-trigger')
        if (triggerButton && !triggerButton.contains(event.target)) {
          this.isOnSelectProduct = false
        }
      }
    },
    toggleProductSelection(productId) {
      const isSelected = this.formData.product_ids.includes(productId)
      if (!isSelected && this.formData.product_ids?.length >= 5) {
        this.$nextTick(() => {
          if (this.formData.product_ids.includes(productId) && this.formData.product_ids?.length > 5) {
            this.formData.product_ids = this.formData.product_ids.filter(id => id !== productId)
          }
        })
      }
    },
    async getShipmentData() {
      try {
        const { data } = await apiGetShipment()
        const shipmentWithShow = (data.data || []).map(item => {
          const isSelectedId = this.isShipmentSelected(item.id)
          return {
            show: isSelectedId, // show panel if edit mode and id matches
            shipping_name: item.shipping_name,
            image_path: item.image_path,
            id: item.id,
            services: [
              {
                service_name: 'Regular',
                is_selected: this.isServiceSelected(item.id, 'regular'),
                value: 'regular',
              },
              ...(item.is_cargo
                ? [{
                  service_name: 'Trucking / Cargo',
                  value: 'cargo',
                  is_selected: this.isServiceSelected(item.id, 'cargo'),
                }]
                : []
              ),
            ],
          }
        })
        this.shipment = shipmentWithShow

        // Update shipment selection if in edit mode
        if (this.isEditMode && this.formData.shipments && this.formData.shipments.length > 0) {
          this.updateShipmentSelection()
        }

        // Validate form after loading shipment data
        this.validateForm()
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data Expedisi' })
        this.shipment = []
      }
    },
    isShipmentSelected(id) {
      if (this.formData.shipments && this.formData.shipments.length > 0) {
        return this.formData.shipments.some(s => s.shipment_id === id)
      }
      return false
    },
    isServiceSelected(id, type) {
      if (this.formData.shipments && this.formData.shipments.length > 0) {
        return this.formData.shipments.some(s => s.shipment_id === id && s.shipment_type === type)
      }
      return false
    },
    getCoverageLabel(value) {
      const option = this.coverageOptions.find(opt => opt.value === value)
      return option ? option.label : value
    },
    isCoverageSelectable(option) {
      if (!option || !option.value) return true
      if (this.selectedCoverages.includes('indonesia')) {
        return option.value === 'indonesia'
      }
      if (option.value === 'indonesia') {
        return this.selectedCoverages.length === 0
      }
      return true
    },
    addCoverage(selectedOption) {
      if (!selectedOption) {
        this.selectedCoverage = null
        return
      }
      const { value } = selectedOption
      if (value === 'indonesia') {
        this.selectedCoverages = ['indonesia']
        this.formData.coverage_discount = ['indonesia']
        this.selectedCoverage = null
        return
      }
      if (this.selectedCoverages.includes('indonesia')) {
        this.selectedCoverage = null
        return
      }
      if (!this.selectedCoverages.includes(value)) {
        this.selectedCoverages.push(value)
        this.formData.coverage_discount = [...this.selectedCoverages]
      }
      this.selectedCoverage = null
    },
    selectShipment() {
      // Calculate selected shipments based on current state
      const selected = []
      this.shipment.forEach(item => {
        item.services.forEach(service => {
          if (service.is_selected) {
            selected.push({
              shipment_id: item.id,
              shipment_type: service.value,
            })
          }
        })
      })

      // Update formData.shipments
      this.$set(this.formData, 'shipments', selected)
      this.validateForm()
    },
    removeCoverage(value) {
      this.selectedCoverages = this.selectedCoverages.filter(coverage => coverage !== value)
      this.formData.coverage_discount = [...this.selectedCoverages]
    },
    updateShipmentSelection() {
      if (this.shipment.length === 0) {
        return
      }

      const shipments = this.formData.shipments || []

      this.shipment = this.shipment.map(shipmentItem => {
        let hasSelection = false
        const services = shipmentItem.services.map(s => {
          const isSelected = shipments.some(sel => sel.shipment_id === shipmentItem.id && sel.shipment_type === s.value)

          if (isSelected) hasSelection = true
          return {
            ...s,
            is_selected: isSelected,
          }
        })
        return {
          ...shipmentItem,
          services,
          show: hasSelection || shipmentItem.show,
        }
      })
    },
    onPromoDiscountToggle() {
      if (!this.promoEnabled) {
        this.formData.product_discount = 0
        this.formData.payment_discount = 0
        this.formData.shipping_discount = 0
        this.formData.coverage_discount = []
      }
    },
    async loadProducts(reset = false) {
      if (this.isLoadingProducts || (!this.hasMoreProducts && !reset)) {
        return
      }

      try {
        this.isLoadingProducts = true

        if (reset) {
          this.productPage = 0
          this.hasMoreProducts = true
          this.localProductList = []
        }

        // Calculate offset based on existing products length
        const offset = this.localProductList.length

        const { data } = await apiGetProuctList({
          keyword: this.searchKeyword,
          page: offset,
          limit: this.productLimit,
        })

        const products = data?.data || []

        if (reset) {
          this.localProductList = products
        } else {
          this.localProductList = [...this.localProductList, ...products]
        }

        if (products.length < this.productLimit) {
          this.hasMoreProducts = false
        }
      } catch (error) {
        console.error('Error loading products:', error)
        this.$toast_error({ message: error.message || 'Gagal memuat produk' })
        this.hasMoreProducts = false
      } finally {
        this.isLoadingProducts = false
      }
    },
    handleProductScroll(event) {
      if (this.scrollDebounceTimer) {
        clearTimeout(this.scrollDebounceTimer)
      }

      this.scrollDebounceTimer = setTimeout(() => {
        const { scrollTop, scrollHeight, clientHeight } = event.target || event
        const threshold = 100
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight

        if (distanceFromBottom < threshold && !this.isLoadingProducts && this.hasMoreProducts) {
          this.loadProducts()
        }
      }, 150)
    },
    onProductSearch(search, loading) {
      this.searchKeyword = search
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.loadProducts(true)
      }, 500)
    },
    onProductDropdownOpen() {
      this.isProductSelectOpen = true
      this.$nextTick(() => {
        const dropdown = this.$el.querySelector('.vs__dropdown-menu')
        if (dropdown) {
          dropdown.addEventListener('scroll', this.handleProductScroll)
        }
        const searchInput = this.$el.querySelector('.vs__search')
        if (searchInput) {
          searchInput.focus()
        }
      })
    },
    onProductDropdownClose() {
      this.isProductSelectOpen = false
      const dropdown = this.$el.querySelector('.vs__dropdown-menu')
      if (dropdown) {
        dropdown.removeEventListener('scroll', this.handleProductScroll)
      }
    },
    getProductPriceAfterDiscount(product) {
      const originalPrice = Number(product.product_price || product.price) || 0

      // Calculate product discount
      const productDiscountPercent = Number(this.formData.product_discount) || 0
      const productDiscountAmount = (originalPrice * productDiscountPercent) / 100
      const priceAfterProductDiscount = originalPrice - productDiscountAmount

      // Calculate payment discount
      const paymentDiscountPercent = Number(this.formData.payment_discount) || 0
      const paymentDiscountAmount = (priceAfterProductDiscount * paymentDiscountPercent) / 100
      const finalPrice = priceAfterProductDiscount - paymentDiscountAmount

      return Math.round(finalPrice)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/vue/libs/vue-select.scss';

.custom-product-select {
  ::v-deep .vs__selected {
    display: none !important;
  }
}

</style>
